// extracted by mini-css-extract-plugin
module.exports = {"control":"Control_control__74-mt","button":"Control_button__3ROsh"};